import {
  init,
  reactRouterV5BrowserTracingIntegration,
  replayIntegration,
} from '@sentry/react';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useConfig } from '../ConfigProvider';

const Sentry: FC = () => {
  const history = useHistory();
  const { environment } = useConfig();

  useEffect(() => {
    const sentryEnvironment = environment || process.env.NODE_ENV;
    const enabled =
      ![
        'partner.artemis.swaarm-clients.com',
        'partner.ares.swaarm-clients.com',
        'partner.mars.swaarm-clients.com',
        'partner.demo.swaarm-clients.com',
        'partner.buster.swaarm-clients.com',
        'partner.saturn.swaarm-clients.com',
        'partner.mercury.swaarm-clients.com',
        'partner.venus.swaarm-clients.com',
        'partner.phoenix.swaarm-clients.com',
        'partner.gaia.swaarm-clients.com',
      ].includes(window.location.hostname) &&
      sentryEnvironment === 'production';

    init({
      dsn: 'https://cf1692f59deb9086892336a268fdfb52@o195603.ingest.us.sentry.io/4507413706833920',
      enabled,
      environment: sentryEnvironment,
      ignoreErrors: [
        'ResizeObserver loop',
        'useRequest has caught the exception',
      ],
      integrations: [
        reactRouterV5BrowserTracingIntegration({
          history,
        }),
        replayIntegration(),
      ],
      normalizeDepth: 10,
      release: `partner-${VERSION}`,
      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1.0,
      // This sets the sample rate to be 1%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.01,
      tracesSampleRate: 0.01,
    });
  }, [environment, history]);

  return null;
};

Sentry.displayName = 'Sentry';

export default Sentry;
